import React, { Component } from "react";

class Range extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || 0,
			step: props.step || 1
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.setState({ value: this.props.value });
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	handleChange(e) {
		e.preventDefault();

		let value = e.target.value;

		this.setState({
			value: value
		});

		this.props.onChange(value);
	}

	render() {
		const { className, max, min, step } = this.props;
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "range-offers";

		const style = ["range-component", className].join(" ");

		return (
			<div className={style} data-action={dataAction}>
				<input
					className="range-component__range"
					type="range"
					onChange={this.handleChange}
					value={this.state.value}
					min={min}
					max={max}
					step={step}
				/>
			</div>
		);
	}
}

export default Range;
